import { ChangeDetectorRef, Component, Input } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { ProductLine } from '../../../models'
import { MbWishListService } from '../../../wishlist/services/mb-wishlist.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'mb-product-line-wishlist',
  templateUrl: './product-line-wishlist.component.html',
  styleUrls: ['./product-line-wishlist.component.scss']
})
export class ProductLineWishlistComponent {

  @Input() product: ProductLine | undefined

  userLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn()

  constructor (protected wishListService: MbWishListService,
               protected authService: AuthService,
               protected cdRef: ChangeDetectorRef) { }

  add (product: ProductLine) {
    if (product?.code) {
      this.wishListService.addEntry(product.code)
    }
  }

  remove (product: ProductLine) {
    if (product?.code) {
      this.wishListService.removeEntry(product?.code)
      setTimeout(() => {
        this.cdRef.detectChanges()
      }, 1500)
    }
  }

  isProductInWishlist (product: ProductLine) {
    return this.wishListService.isProductInWishlist(product?.code)
  }

  navigateToLoginPage (): void {
    this.authService.loginWithRedirect()
  }
}
